import React from 'react';
// import { Link } from 'react-router-dom';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Footer, Header } from '../Common';
import { SearchBox } from '../Common/SearchBox';
import Pagination from "react-js-pagination";
import AffiliatorLinks from '../../Models/AffiliatorLinks';
class AffiliateChildManagement extends React.Component {
    constructor(props) {
        super(props);
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            activePage: 1,
            productsList: [],
            user: logged_user
        }
        console.log(this.props.match.params.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
    }
    componentWillMount() {
        AffiliatorLinks.getAffsoldProducts(this.props.match.params.id, this.state.user.id, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ productsList: res.data.payload })
            }
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid" style={{minHeight:'350px'}}>
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div> */}
                            <div className="col-md-8">
                                <div className="input_name big_font text-left" style={{ width: '100%', fontSize: '20px' }}>
                                    アフィリエタ管理
                                </div>
                                <div className="">
                                    <table className="table_individual ">
                                        <tbody>
                                            <tr>
                                                <td className="" style={{ width: "28%", fontSize: '13px' }}>
                                                    <b>サービス名</b>
                                                </td>
                                                <td style={{ width: '27%', fontSize: '13px' }}>
                                                    <strong>ユーザー名</strong>
                                                </td>
                                                <td style={{ width: '17%', fontSize: '13px' }}>
                                                    <b>報酬 </b>
                                                </td>
                                                <td style={{ width: '28%', fontSize: '13px' }}>
                                                    <b>販売日</b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {(() => {
                                        if (this.state.productsList.length === 0) {
                                            return (
                                                <div></div>
                                            )
                                        } else {
                                            return (
                                                <table className="table_individual ">
                                                    <tbody>
                                                        {this.state.productsList.map(group =>
                                                            <tr>
                                                                <td className="" style={{ width: "28%", fontSize: '13px' }}>
                                                                    {group.title}
                                                                </td>
                                                                <td style={{ width: '27%', fontSize: '13px' }}>
                                                                    {group.first_name}
                                                                </td>
                                                                <td style={{ width: '17%', fontSize: '13px' }}>
                                                                    {parseInt(group.earning_amount)}
                                                                </td>
                                                                <td style={{ width: '28%', fontSize: '13px' }}>
                                                                    {(JSON.stringify(group.created_at)).substring(1, 11)}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            )
                                        }
                                    })()}
                                    {/* <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-8 ml-5 mt-4">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={450}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div><br /><br /></div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left">
                                            アフィリエタ管理
                                    </div>
                                        <div className="row">
                                            {/* <div className="col-md-8 mr-5 pr-5">
                                                <SearchBox />
                                            </div> */}
                                            {/* <div className="col-md-2 mt-2 pt-2">
                                            <button type="submit" className="btn btn-success">サーチ </button>
                                        </div> */}
                                            <table className="table_individual ml-3">
                                                <tbody>
                                                    <tr>
                                                        <td className="" style={{ width: "28%", fontSize: '13px' }}>
                                                            <b>
                                                                サービス名
                                                        </b>
                                                        </td>
                                                        <td style={{ width: '27%', fontSize: '13px' }}>
                                                            <strong>
                                                                ユーザー名
                                                        </strong>
                                                        </td>
                                                        <td style={{ width: '17%', fontSize: '13px' }}>
                                                            <b>
                                                                報酬
                                                        </b>
                                                        </td>
                                                        <td style={{ width: '28%', fontSize: '13px' }}>
                                                            <b>
                                                                販売日
                                                        </b>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {(() => {
                                                if (this.state.productsList.length === 0) {
                                                    return (
                                                        <div></div>
                                                    )
                                                } else {
                                                    return (
                                                        <table className="table_individual ml-3">
                                                            <tbody>
                                                                {this.state.productsList.map(group =>
                                                                    <tr>
                                                                        <td className="" style={{ width: "28%", fontSize: '13px' }}>
                                                                            {group.title}
                                                                        </td>
                                                                        <td style={{ width: '27%', fontSize: '13px' }}>
                                                                            {group.first_name}
                                                                        </td>
                                                                        <td style={{ width: '17%', fontSize: '13px' }}>
                                                                            {parseInt(group.earning_amount)}
                                                                        </td>
                                                                        <td style={{ width: '28%', fontSize: '13px' }}>
                                                                            {(JSON.stringify(group.created_at)).substring(1, 11)}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    )
                                                }
                                            })()}
                                            {/* <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-8 ml-5 mt-4">
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={450}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChange.bind(this)}
                                                />
                                            </div>
                                            <div className="col-md-2"></div>
                                        </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div><br /><br /><br /></div>
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliateChildManagement }